import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { getEndpoint } from 'src/app/core/services/functions.service';

export interface AgrupacionNovedad {
  id?: number;
  codigoagrupacion: string;
  codigonovedad: string;
  c_emp: string;
  usuariocreacion?: string;
  fechacreacion?: Date;
  usuariomodificacion?: string;
  fechamodificacion?: Date;
  estado: string;
}

export interface AgrupacionNovedadCreate extends Omit<AgrupacionNovedad, 'id' | 'fechacreacion' | 'fechamodificacion'> {
  // Omitimos el id y las fechas ya que serán generados por el backend
}

@Injectable({
  providedIn: 'root'
})
export class AgrupacionNovedadesService {
  
  ENDPOINT = getEndpoint('coms_agrupa_novedad');

  constructor(private http: HttpClient) { }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Ocurrió un error en la comunicación con el servidor';
    
    if (error.error instanceof ErrorEvent) {
      // Error del lado del cliente
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // El backend retornó un código de error
      errorMessage = `Error ${error.status}: ${error.error?.detail || error.message}`;
    }
    
    return throwError(() => new Error(errorMessage));
  }

  getAllAgrupaciones(company: string): Observable<AgrupacionNovedad[]> {
    return this.http.get<AgrupacionNovedad[]>(`${this.ENDPOINT}`, {
      headers: { 'company': company }
    }).pipe(
      catchError(this.handleError)
    );
  }

  getAgrupacion(id: number,company: string): Observable<AgrupacionNovedad> {
    return this.http.get<AgrupacionNovedad>(`${this.ENDPOINT}/${id}`, {
      headers: { 'company': company }
    }).pipe(
      catchError(this.handleError)
    );
  }

  createAgrupacion(agrupacion: AgrupacionNovedadCreate, company: string): Observable<{message: string}> {
    return this.http.post<{message: string}>(this.ENDPOINT, agrupacion, {
      headers: { 'company': company }
    }).pipe(
      catchError(this.handleError)
    );
  }

  updateAgrupacion(id: number, agrupacion: Partial<AgrupacionNovedad>, company: string): Observable<AgrupacionNovedad> {
    return this.http.put<AgrupacionNovedad>(`${this.ENDPOINT}/${id}`, agrupacion, {
      headers: { 'company': company }
    }).pipe(
      catchError(this.handleError)
    );
  }

  deleteAgrupacion(id: number, company: string  ): Observable<any> {
    return this.http.delete(`${this.ENDPOINT}/${id}`, {
      headers: { 'company': company }
    }).pipe(
      catchError(this.handleError)
    );
  }
}
